<template>
    <div class="header px-0" >
        <div class="container d-flex align-items-center justify-content-between">
            <img src="../assets/images/logo.png" alt="" height="40px">
            <div class="menu-wrapper d-none d-lg-flex">
                <div v-for="(item, index) in menu" :key="'menu' + index">
                    <b-dropdown :text="$t(item.title)" v-if="item.sub.length>0">
                        <b-dropdown-item href="#" v-for="jtem in item.sub" :key="jtem"
                            @click="handleLink(item.title, jtem)">{{ $t(jtem) }}</b-dropdown-item>
                    </b-dropdown>
                    <b-button v-else class="font-weight-600" @click="$router.push('/'+item.title)">
                        {{ $t(item.title) }}
                    </b-button>
                </div>
            </div>
            <b-dropdown id="dropdown-lang" left variant="link" toggle-class="my-dropdown" @show="toggleDropdown"
                @hide="toggleDropdown">
                <template #button-content>
                    <span>
                        <span v-if="$i18n.locale == 'zh'">
                            <img src="../assets//images/flag/zh.png" height="30px"/>
                        </span>
                        <span v-else-if="$i18n.locale == 'zh_hant'">
                            <img src="../assets/images/flag/zhHant.png" height="30px"/>
                        </span>
                        <span v-else-if="$i18n.locale == 'my'">
                            <img src="../assets/images/flag/my.png" height="30px"/>
                        </span>
                        <span v-else>
                            <img :src="require(`../assets/images/flag/${$i18n.locale}.png`)" height="30px"/>
                        </span>
                    </span>
                </template>
                <b-dropdown-item href="#" @click="$root.changeLan('en')">English</b-dropdown-item>
                <b-dropdown-item href="#" @click="$root.changeLan('zh')">中文（简体）</b-dropdown-item>
                <b-dropdown-item href="#" @click="$root.changeLan('zh_hant')">中文（繁体）</b-dropdown-item>
                <b-dropdown-item href="#" @click="$root.changeLan('kr')">한국인</b-dropdown-item>
                <b-dropdown-item href="#" @click="$root.changeLan('vn')">tiếng Việt</b-dropdown-item>
                <b-dropdown-item href="#" @click="$root.changeLan('th')">แบบไทย</b-dropdown-item>
                <b-dropdown-item href="#" @click="$root.changeLan('rs')">русский</b-dropdown-item>
                <!-- <b-dropdown-item href="#" @click="$root.changeLan('my')">Bahasa Melayu</b-dropdown-item> -->
            </b-dropdown>
            <div class="d-flex align-items-center">
                <b-button class="text-nowrap" variant="primary" target="_blank"
                    :href="'/web/sessions/login'">
                    {{ $t('login') }}
                </b-button>
                <b-button class="d-lg-none" variant="link" @click="sidebarOpen = true">
                    ☰
                </b-button>
            </div>
        </div>
        <b-sidebar
            id="sidebar-right"
            title="Menu"
            right
            shadow
            :visible="sidebarOpen"
            @hidden="sidebarOpen = false"
            >
            <div v-for="(item, index) in menu" :key="'sidebar-menu' + index" class="mb-2">
                <b-dropdown :text="$t(item.title)" v-if="item.sub.length>0" block>
                <b-dropdown-item
                    v-for="jtem in item.sub"
                    :key="jtem"
                    @click="handleLink(item.title, jtem)"
                >
                    {{ $t(jtem) }}
                </b-dropdown-item>
                </b-dropdown>
                <b-button v-else block @click="$router.push('/'+item.title)">
                {{ $t(item.title) }}
                </b-button>
            </div>
        </b-sidebar>
    </div>
</template>
<script>
export default {
    name: 'Header',
    data() {
        return {
            menu: [
                { title: 'about_us', sub: ['homepage', 'why_us', 'ourLicensing', 'legal', 'faq'], },
                { title: 'trading', sub: ['account_type', 'deposit_n_withdrawal', 'mt5TradingPlatform', 'fixApi'], },
                { title: 'portfolio', sub: ['pamm', 'portfolio_management'], },
                { title: 'partnerships', sub: [], }
            ],
            dropdownOpen: false,
            sidebarOpen: false,
        }
    },
    methods: {
         handleLink(title, sub) {
            if(title === 'about_us') this.$router.push(`/${sub}`)
            else this.$router.push(`/${title}/${sub}`)
            this.sidebarOpen = false 
        },
        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        }
    }

}</script>